import {JsonClassType, JsonProperty, ObjectMapper} from "@outfoxx/jackson-js";
import {JsonClassTypeOptions, JsonParserContext} from "@outfoxx/jackson-js/dist/@types";
import {Channel} from "modules/subscribe/share-app/api/entity/Channel";
import {ArrayCollection} from "lib/base/collection";
import {Property} from "modules/public-organization/src/Entity/Notice";

export class GroupedChannels {
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> { type: () => [ArrayCollection, [Channel]] })
    readonly email?: Channel[];
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> { type: () => [ArrayCollection, [Channel]] })
    readonly telegram?: Channel[];
}

export class Subscribe {
    @JsonProperty()
    readonly id: string|null;
    @JsonProperty()
    readonly entityId: string|null;
    @JsonProperty()
    readonly entityName: string|null;
    @JsonProperty()
    readonly moduleTitle: string|null;
    @JsonProperty()
    readonly previewText: string|null;
    @JsonProperty()
    readonly subscribeChannels: GroupedChannels;

    public static createByObj(object: object | null): Subscribe {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<Subscribe>(JSON.stringify(object), { mainCreator: () => [Subscribe] } as JsonParserContext);
    }
}
